import Vue from "vue";
import App from "./App.vue";
import "./assets/style.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faEye,
  faEdit,
  faChevronLeft,
  faChevronRight,
  faSignOutAlt,
  faDownload
} from "@fortawesome/free-solid-svg-icons";
import { faTwitter } from "@fortawesome/free-brands-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
  faEye,
  faEdit,
  faChevronLeft,
  faChevronRight,
  faSignOutAlt,
  faTwitter,
  faDownload
);

Vue.component("icon", FontAwesomeIcon);

Vue.config.productionTip = false;

new Vue({
  el: "#app",
  render: h => h(App)
});
